<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>FILTRI</v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="6" sm="5" xs="12">
                <v-autocomplete clearable :items="suppliers" v-model="filters.selectedSupplier" label="Fornitori"
                  item-text="an_descr1" item-value="an_conto" @change="getProduct()">
                </v-autocomplete>
              </v-col>
              <v-col md="2" sm="5" xs="12"> </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card v-if="shop_group_supplier_info">
          <v-card-title>ORDINI</v-card-title>
          <v-card-text>
            <v-row>
              <v-col md="10">
                {{ shop_group_supplier_info.header_text }}
              </v-col>
              <v-col md="2">
                <v-btn @click="restockReset(filters.selectedSupplier)" small color="warning">
                  Azzera
                </v-btn>
                <v-btn :href="'/api/restock-excel?sup_id='+filters.selectedSupplier" color="primary">
                  Scarica
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-card>
          <v-data-table :headers="headers" :items="products" :items-per-page="20" :footer-props="{
            'items-per-page-options': [20, 50, 100, 200, -1],
          }" item-key="id" class="elevation-1" :loading="loading" loading-text="Caricamento in corso..."
            calculate-widths dense>
            <template v-slot:header.tot_euro="{header}">
              TOTALE <br />
              {{calcoloTotale() | formatEuro}}
            </template>
            <template v-slot:item.foto="{ item }">
              <div style="text-align: center">
                <a :href="getImagePath(item.ar_codart)" _target="_blank">
                  <img height="60px" :src="getImagePath(item.ar_codart)"
                    onerror="javascript: this.src='/no_image.jpg';" />
                </a>
              </div>
            </template>
            <template v-slot:item.ar_codart="{ item }">
              <a :href="'/product?id=' + item.ar_codart" target="_blank">{{
              item.ar_codart
              }}</a>
            </template>
            <template v-slot:item.lc_prezzo5="{ item }">
              <span v-if="shop_group_supplier_info.group.type == 'franchise'">
                {{calcoloScontoFrancising(item) | formatEuro}}
              </span>
              <span v-else>{{ item.lc_prezzo5 | formatEuro }}</span>
            </template>
            <template v-slot:item.qta_ordinato="{ item }">
              <v-text-field min="0" v-model="item.qta_ordinato" type="number" dense solo
                @change="calcTotConf(item); calcTotEuro(item); saveProduct(item);">
              </v-text-field>
            </template>
            <template v-slot:item.tot_conf="{ item }">
              {{ calcTotConf(item) }}
            </template>
            <template v-slot:item.tot_euro="{ item }">
              {{ calcTotEuro(item) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">

</style>
<script>
import requests from "../requests";
import helpers from "../helpers";
export default {
  name: "create-order-page",
  data: () => {
    return {
      loading: false,
      shop_group_supplier_info: null,
      products: [],
      suppliers: [],
      user: null,
      defaultItem: {
        ar_descr: "",
        note: ""
      },
      editedItem: {
        ar_descr: "",
        note: ""
      },
      dialog: false,
      filters: {
        selectedSupplier: null,
        selectedGroup: null,
      },
      groupData: {
        headerText: ""
      }
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    headers() {
      return [
        { value: "foto", sortable: false },
        //{ text: "ID", value: "shopify_id" },
        {
          text: "Cod Articolo",
          value: "ar_codart",
          filter: (f) => {
            if (!this.filters.ar_codart) return true;
            return f.indexOf(this.filters.ar_codart) > -1;
          },
        },
        {
          text: "Desc",
          value: "ar_descr",
          filter: (f) => {
            if (!this.filters.ar_descr) return true;
            return f.indexOf(this.filters.ar_descr.toUpperCase()) > -1;
          },
        },
        {
          text: "Cod Forn.",
          value: "ar_codforn",
          filter: (f) => {
            if (!this.filters.ar_codforn) return true;
            return f == this.filters.ar_codforn;
          },
        },
        {
          text: "Barcode",
          value: "bc_code",
          filter: (f) => {
            if (!this.filters.bc_code) return true;
            return f == this.filters.bc_code;
          },
        },
        {
          text: "Magazzino",
          value: "xx_giacenzafin",
        },
        {
          text: "Prz Acq",
          value: "lc_prezzo5",
        },
        {
          text: "Min Ord",
          value: "ar_minordinabile",
        },
        {
          text: "INNER",
          value: "ar_inner",
        }, {
          text: "CARTONE",
          value: "ar_cartonaggio"
        },
        {
          text: "QTA IDEALE",
          value: "qta_ideale",
        },
        {
          text: "ORDINATO",
          value: "qta_ordinato",
        },
        {
          text: "TOT CONF",
          value: "tot_conf",
        },
        {
          text: "TOT EURO",
          value: "tot_euro",
        },
        {
          text: "NOTE",
          value: "note",
        },
      ];
    },
  },
  mounted() {
    console.log("Create order page Mounted.");
    this.getSuppliers();
    this.user = window.currentUser;
    //this.getProduct();
  },

  filters: {
    formatEuro(number) {
      if (_.isNaN(number)) return 0;
      return new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }).format(number);
    },
  },
  methods: {
    getSuppliers() {
      requests.getSuppliersForRestock().then(res => {
        this.suppliers = res.data;
      });
    },

    calcoloTotale() {
      let sum = 0;
      _.forEach(this.products, (item) => {
        let prezzo = item.lc_prezzo5;
        if (this.shop_group_supplier_info.group.type == 'franchise') prezzo = this.calcoloScontoFrancising(item);
        sum += (item.qta_ordinato * prezzo);
      })
      return sum;
    },

    calcoloScontoFrancising(product) {
      let prezzo = product.lc_prezzo2;
      let sconto1 = product.so_sconto1l3;
      let sconto2 = product.so_sconto2l3;
      let ris = prezzo - (prezzo * sconto1) / 100;
      return ris - (ris * sconto2) / 100;
    },

    getImagePath(a) {
      return helpers.getImagePath(a);
    },

    saveProduct(item) {
      requests.saveNumOrder(item);
    },

    calcTotConf(item) {
      let num = (parseInt(item.qta_ordinato) / parseInt(item.ar_cartonaggio));
      if (_.isNaN(num)) num = 0;
      num = Math.ceil(num);
      item.tot_conf = num;
      return num;
    },

    calcTotEuro(item) {
      let prezzo = item.lc_prezzo5;
      if (this.shop_group_supplier_info.group.type == 'franchise') prezzo = this.calcoloScontoFrancising(item);
      let num = (item.qta_ordinato * prezzo);
      if (_.isNaN(num)) num = 0;
      item.tot_euro = num;
      return this.$options.filters.formatEuro(num);
    },

    getProduct() {
      this.loading = true;
      requests.readProductForRestock(this.filters.selectedSupplier).then((res) => {
        this.products = res.data.products;
        this.shop_group_supplier_info = res.data.shop_group_supplier_info;
        this.loading = false;
      });
    },
    saveGroupData() {
      requests.saveShopGroupData(this.filters.selectedGroup, this.selectedGroupObject.data);
    },
    editItem(item) {
      this.editedItem = item;
      this.dialog = true;
    },

    restockReset(supId) {
      if (window.confirm("Azzerare l'ordine?"))
        requests.restockReset(supId).then(res => {
          this.getProduct();
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>
